import { axiosYt } from "@/services/axios-yt";

function getPageMetaData(pathname) {
  return axiosYt.get(pathname, { params: { get_page_meta_data: "Y" } });
}

export function usePageMeta() {
  return {
    getPageMetaData,
  };
}
